import gql from 'graphql-tag';

export const mutationSendOnboardingStartEmail = gql`
  mutation sendOnboardingStartEmail (
    $primaryEmail: String!
    $queryString: String
  ) {
    sendOnboardingStartEmail (
      primaryEmail: $primaryEmail
      queryString: $queryString
    )
  }
`;
export default mutationSendOnboardingStartEmail;
